export default "/images/14 Step3TakeAction-Provider-To access tips and materials-01.png?c01404e7035935d42d83d4657ec4faad";